import { Heading, Link, Stack, Text } from '@chakra-ui/react';

export const PrivacyDe = () => {
  return (
    <div>
      <Heading as="h1" size="md" mt={4}>
        DATENSCHUTZERKLÄRUNG SUP SUP CLUB
      </Heading>
      <Stack gap={4} mt={4}>
        <Text>
          Wenn du bei SUP SUP CLUB ein SUP-Board mieten möchtest oder eine
          Bestellung über unsere Website (www.supsupclub.com) aufgibst,
          benötigen wir einige persönliche Daten von dir. In dieser
          Datenschutzerklärung möchten wir dir erklären, warum wir diese
          personenbezogenen Daten benötigen und was wir damit machen.
        </Text>
        <Text>
          Sup Sup Club legt großen Wert auf Datenschutz und setzt sich für den
          Schutz der Privatsphäre seiner Teilnehmer ein. Wir speichern,
          verarbeiten und sichern personenbezogene Daten sorgfältig. Wir halten
          alle Verpflichtungen ein, die sich aus der Datenschutz-Grundverordnung
          (Verordnung (EU) 2016/679) (DSGVO) und anderen Datenschutzgesetzen
          ergeben.
        </Text>
        <Text>
          Die Sup Sup Club B.V. hat ihren Sitz in der Herengracht 406 (1017 BX)
          in Amsterdam. Die Verleihstationen befinden sich an verschiedenen
          Standorten in den Niederlanden (die genauen Adressen findest du auf
          unserer Website unter Standorte).
        </Text>
        <Heading size="md">Welche personenbezogenen Daten erheben wir?</Heading>
        <ul>
          <li>Vor- und Nachname;</li>
          <li>Geschlecht;</li>
          <li>Geburtsdatum;</li>
          <li>E-Mail-Adresse;</li>
          <li>(Mobil-)Telefonnummer;</li>
          <li>Adressdaten;</li>
          <li>Bankdaten;</li>
          <li>
            Informationen über deinen Besuch bei Sup Sup Club (Ein- und
            Ausgangszeiten der gemieteten SUP-Boards und gebuchten Kurse);
          </li>
          <li>Transaktionsdaten aus Bestellungen; und</li>
          <li>IP-Adressen, Betriebssystem, Browsertyp und Zeitstempel.</li>
        </ul>
        <Text>Wir verwenden diese Daten für folgende Zwecke:</Text>
        <ul>
          <li>Erstellen, Versenden und Vorbereiten von Rechnungen;</li>
          <li>Bereitstellung von Informationen;</li>
          <li>Verbesserung unserer Dienstleistungen;</li>
          <li>
            Beantwortung von Fragen, die z.B. über die Website gestellt werden;
          </li>
          <li>
            gegebenenfalls Bereitstellung von Informationen über neue Produkte
            und Dienstleistungen; und
          </li>
          <li>
            Erfüllung unserer Verpflichtungen aus Verträgen, die wir mit dir
            geschlossen haben, sowie für die Rechnungsstellung und Lieferung.
          </li>
        </ul>
        <Text>
          Die Grundlage für die Verarbeitung ist die Erfüllung des Vertrags mit
          dir und gesetzliche Verpflichtungen.
        </Text>
        <Heading size="md">
          Weitergabe personenbezogener Daten an Dritte
        </Heading>
        <Text>
          Wir verkaufen, handeln oder geben personenbezogene Daten nicht ohne
          deine ausdrückliche Zustimmung an Dritte weiter. Deine
          personenbezogenen Daten werden nur weitergegeben, wenn wir gesetzlich
          dazu verpflichtet sind.
        </Text>
        <Heading size="md">Auftragsverarbeiter</Heading>
        <Text>
          Um unsere Dienstleistungen erbringen zu können, nutzen wir andere
          Auftragsverarbeiter, wie z.B. Adyen für die Zahlungsabwicklung. Wir
          stellen sicher, dass auch unsere Auftragsverarbeiter personenbezogene
          Daten gemäß der DSGVO verarbeiten.
        </Text>
        <Heading size="md">Deine Rechte</Heading>
        <Text>
          Du hast jederzeit das Recht auf Einsicht in die personenbezogenen
          Daten, die wir über dich gespeichert haben. Wenn diese Daten
          fehlerhaft sind, kannst du uns helfen, sie zu korrigieren, oder uns
          bitten, die Verarbeitung einzuschränken. Du hast auch das Recht, uns
          zu bitten, deine personenbezogenen Daten zu löschen oder dir auf einem
          Datenträger zur Verfügung zu stellen. Solchen Anfragen wird stets
          nachgekommen. Du kannst diese Rechte ausüben, indem du eine E-Mail an
          die Kontaktadresse auf der Website sendest. Darüber hinaus kannst du
          jederzeit der Verarbeitung deiner personenbezogenen Daten
          widersprechen.
        </Text>
        <Heading size="md">
          Wie lange bewahren wir deine personenbezogenen Daten auf?
        </Heading>
        <Text>
          Wir bewahren deine personenbezogenen Daten so lange auf, wie es für
          die Erfüllung der Zwecke, für die wir deine personenbezogenen Daten
          verarbeiten, erforderlich ist. Nach der Kündigung deiner
          Mitgliedschaft werden deine Daten maximal 7 Jahre aufbewahrt.
        </Text>
        <Heading size="md">Sicherheit</Heading>
        <Text>
          Aufgrund der Art unserer Dienstleistungen und des Vertrauens, das du
          in uns setzen können musst, treffen wir unter Berücksichtigung des
          Stands der Technik und der Implementierungskosten angemessene
          technische und organisatorische Maßnahmen, um sicherzustellen, dass
          die Verarbeitung personenbezogener Daten im Einklang mit der DSGVO
          erfolgt.
        </Text>
        <Heading size="md">Datenschutzbehörde</Heading>
        <Text>
          Selbstverständlich helfen wir dir gerne weiter, wenn du Beschwerden
          über die Verarbeitung deiner personenbezogenen Daten hast. Gemäß der
          DSGVO hast du auch das Recht, eine Beschwerde bei der
          Datenschutzbehörde gegen eine solche Verarbeitung personenbezogener
          Daten einzureichen. Dazu kannst du dich an die Datenschutzbehörde
          wenden.
        </Text>
        <Heading size="md">Änderungen</Heading>
        <Text>
          Sup Sup Club behält sich das Recht vor, diese Datenschutzerklärung zu
          ändern und anzupassen.
        </Text>
        <Text>
          Wenn du Fragen hast, kontaktiere uns bitte unter{' '}
          <Link href="mailto:info@supsupclub.com">info@supsupclub.com</Link>.
        </Text>
        <Text>
          Diese Datenschutzerklärung wurde zuletzt am 1. April 2023
          aktualisiert.
        </Text>
      </Stack>
    </div>
  );
};
